import { useState } from 'react';
import { Layer, Map as MapComponent, Source } from 'react-map-gl/mapbox';

import { clusterCountLayer, clusterLayer, unclusteredPointLayer } from './layers.const';

export default function DoohInventoryMap() {
  const [zoom, setZoom] = useState(1);

  return (
    <MapComponent
      attributionControl={false}
      fog={{
        color: '#555',
        'high-color': '#444',
        'horizon-blend': 0.05,
        range: [0.8, 8],
        'space-color': '#000000',
        'star-intensity': 0.25
      }}
      id="inventory-explorer-map"
      logoPosition="bottom-left"
      mapStyle="mapbox://styles/taptap/cl78tjcu2000p14rptx9um21b"
      mapboxAccessToken="pk.eyJ1IjoidGFwdGFwIiwiYSI6IjRSaHpHbUEifQ.2bAMMlWkzbPiVWA6dCE2Wg"
      maxZoom={14}
      minZoom={1}
      // @ts-ignore
      onMove={e => setZoom(e.viewState.zoom)}
      projection="globe"
    >
      {zoom < 12 ? (
        <Source
          id="inventory-explorer-source-id"
          key="inventory-explorer-source-key"
          type="vector"
          url={`mapbox://taptap.cba37fpg?accessToken=${taptap.config.inventoryExplorerMapToken}`}
        >
          <Layer {...clusterLayer} />
          <Layer {...clusterCountLayer} />
        </Source>
      ) : (
        <Source
          id="inventory-explorer-source-id-unclustered"
          key="inventory-explorer-source-key-unclustered"
          type="vector"
          url={`mapbox://taptap.c7i4ambs?accessToken=${taptap.config.inventoryExplorerMapToken}`}
        >
          <Layer {...unclusteredPointLayer} />
        </Source>
      )}
    </MapComponent>
  );
}
